import { Button, Chip, Dialog, DialogActions, DialogContent, Grid, IconButton, Paper, Stack, Typography, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { CalendarIcon, CheckBoxIcon, CheckedBoxIcon, CloseLineIcon, EmailIcon, LocationIcon, PhoneIcon, UserIcon } from '../../components/IconComponent'
import { useTranslation } from 'react-i18next';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import { emptyStringIfNull, epochToDatetimeStrWithTz, getCustomFieldByKey } from '../../utils/util'
import { Form } from 'react-final-form';
import ScheduleDateNotesView from './ScheduleDateNotesView';

export default function InstallationDetailView(props) {
    console.log('InstallationDetailView props:', props);
    const { orderDetail, activity } = props;
    const { t } = useTranslation()
    const { palette } = useTheme();
    const [note, setNote] = useState(null);

    let items = orderDetail ? dataUtil.createItemsWithComponents(orderDetail.items) : [];
    let addingDevice = getCustomFieldByKey(orderDetail.custom_fields, "adding_device");
    
    const renderStatus = (status) => {
        let label = t(status);
        let color = status == 'COMPLETED' ? 'success' : 'warning'
        return <Chip label={label} variant='customOutlined' size='small' color={color} />
    }

    return (
        <Form
            onSubmit={props.onCompleteActivity(note)}
            render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                    <Dialog
                        open={props.isOpen}
                        onClose={props.onClose}
                        fullWidth={true}
                        maxWidth={"md"}
                        sx={{ '& .MuiDialog-paper': { padding: '0px 0px' } }}
                    >
                        <Stack width={'100%'} height={60} flexDirection={'row'} justifyContent={'flex-start'} alignItems={'center'} paddingX={2}>
                            <IconButton onClick={() => props.onClose()}>
                                <CloseLineIcon />
                            </IconButton>
                            <Typography variant='body1' marginLeft={1} marginRight={1}>Order {orderDetail.number}</Typography>
                            {renderStatus(orderDetail.state)}
                            {orderDetail.stage && <Stack marginLeft={1}><Chip label={orderDetail.stage.name} variant='customOutlined' size='small' /></Stack>}
                            {activity.custom_fields.find(field => field.key === 'status') && <Chip label={activity.custom_fields.find(field => field.key === 'status').value} variant='customOutlined' size='small' sx={{ marginLeft: 1 }} />}

                        </Stack>
                        <DialogContent dividers={true} sx={{
                            padding: '0px 0px'
                        }}>
                            <Grid xs={12} item container direction={'row'} spacing={2} paddingX={2} paddingY={2}>
                                <Grid xs={12} md={6} item>
                                    <Grid xs={12} item component={Paper} paddingX={2} paddingY={2}>
                                        <Stack flex={1} direction={'row'} spacing={1}>
                                            <UserIcon />
                                            {orderDetail.contact && <Stack>
                                                <Typography variant='subtitle2'>{orderDetail.contact.name}</Typography>
                                                <Typography variant='subtitle1' sx={{
                                                    border: '1px solid',
                                                    borderColor: palette.border.main,
                                                    paddingX: 0.5,
                                                    paddingY: 0,
                                                    fontSize: 12,
                                                    borderRadius: 1
                                                }}>{orderDetail.contact.code}</Typography>
                                            </Stack>}
                                        </Stack>
                                        {orderDetail.contact && orderDetail.contact.email_address && <Stack flex={1} direction={'row'} spacing={1} marginTop={1}>
                                            <EmailIcon />
                                            <Typography variant='subtitle2'>{orderDetail.contact.email_address}</Typography>
                                        </Stack>}
                                        {orderDetail.contact && orderDetail.contact.phone_number && <Stack flex={1} direction={'row'} spacing={1} marginTop={1}>
                                            <PhoneIcon />
                                            <Typography variant='subtitle2'>{orderDetail.contact.phone_number}</Typography>
                                        </Stack>}
                                        {orderDetail.contact_address && <Stack flex={1} direction={'row'} spacing={1} mt={1}>
                                            <LocationIcon />
                                            <Typography variant='subtitle2'>{orderDetail.contact_address.address_line_1 +
                                                emptyStringIfNull(orderDetail.contact_address.address_line_2) +
                                                emptyStringIfNull(orderDetail.contact_address.state_province_county) +
                                                emptyStringIfNull(orderDetail.contact_address.town_city) +
                                                emptyStringIfNull(orderDetail.contact_address.postal_code)}
                                            </Typography>
                                        </Stack>}
                                    </Grid>
                                    <Grid xs={12} item component={Paper} paddingX={2} paddingY={2} marginTop={2}>
                                        <Typography marginBottom={1} variant='subtitle1'>{"Product"}</Typography>
                                        {items.map((i, index) => {
                                            if (i.product && i.product.classification != "EXPENSES_SERVICE") {
                                                return <Stack key={index} flex={2}>
                                                    <Stack direction={'row'} spacing={1} alignItems={'flex-end'}>
                                                        <Typography variant='subtitle2'>{i.quantity} x </Typography>
                                                        <Typography variant='subtitle2'>{i.product.name}</Typography>
                                                    </Stack>
                                                </Stack>
                                            } return null;
                                        })}
                                    </Grid>
                                    <Grid xs={12} item component={Paper} paddingX={2} paddingY={2} marginTop={2}>
                                        <Stack flex={1} direction={'row'} spacing={1}>
                                            <CalendarIcon />
                                            {orderDetail.key_dates && <Typography variant='subtitle2'>{"Submitted on "}{epochToDatetimeStrWithTz(orderDetail.key_dates.submitted_on, true)}</Typography>}
                                        </Stack>
                                        <Stack flex={1} direction={'row'} spacing={1}>
                                            {addingDevice && addingDevice == '1' ? <CheckedBoxIcon /> : <CheckBoxIcon />}
                                            <Typography variant='subtitle2'>{t('adding_device')}</Typography>
                                        </Stack>
                                    </Grid>
                                </Grid>
                                <Grid xs={12} md={6} item>
                                    <ScheduleDateNotesView {...props} setNote={setNote} />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Grid xs={12} item container direction={'row'} paddingX={2} paddingY={1} justifyContent={'center'}>
                                <Button sx={{ marginRight: 2 }} variant='contained' onClick={handleSubmit} type='submit'>{t('submit')}</Button>
                                <Button variant='contained' onClick={() => props.onClose()}
                                    sx={{
                                        backgroundColor: palette.info.main
                                    }}
                                >{t('btn_back')}</Button>
                            </Grid>
                        </DialogActions>
                    </Dialog>
                </form>)} />
    )
}